import { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from '@Hooks/index';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';
import { ViewResolver } from '@Components/ViewResolver';
import { useGetRequestsStatusesMutation } from '@Store/api/basicHrmApiSlice';
import { RequestsStatusesResponse } from '@Types/api/dashboardWidgets/RequestsStatuses';
import { useNavigate } from 'react-router-dom';
import ESSFeatureRoutePath from '@Features/router/ess/ESSFeatureRoutePath.enum';
import ReportsDesktop from './desktop';
import ReportsMobile from './mobile';

const initialStatuses = {
  PENDING: 0,
  OPEN: 0,
  APPROVED: 0,
  REJECTED: 0,
};

const Reports: React.FC = () => {
  const currentUser = useAppSelector(currentUserSelector);
  const [getRequestsStatuses] = useGetRequestsStatusesMutation();
  const [requestsStatuses, setRequestStatuses] =
    useState<RequestsStatusesResponse['requestsByStatuses']>(initialStatuses);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser?.empNumber) {
      getRequestsStatuses()
        .unwrap()
        .then((res) =>
          setRequestStatuses({ ...initialStatuses, ...res.requestsByStatuses })
        );
    }
  }, [currentUser?.empNumber]);

  const handleViewAll = useCallback(
    () =>
      navigate(
        `/ess/${ESSFeatureRoutePath.MANAGE_REQUESTS}/${ESSFeatureRoutePath.MANAGE_REQUEST_LEAVE_REQUEST}`
      ),
    []
  );

  return (
    <ViewResolver
      desktop={
        <ReportsDesktop
          requestsStatuses={requestsStatuses}
          handleViewAll={handleViewAll}
        />
      }
      mobile={
        <ReportsMobile
          requestsStatuses={requestsStatuses}
          handleViewAll={handleViewAll}
        />
      }
    />
  );
};

export default Reports;
